<script setup>
/* eslint-disable no-undef */
defineProps({
  items: {
    type: Array,
    required: true,
    // Expected format: [{ text: 'Home', to: '/' }, { text: 'Page', active: true }]
  },
});
/* eslint-enable no-undef */
</script>

<template>
  <nav aria-label="breadcrumb" class="d-breadcrumb">
    <ol class="d-breadcrumb__list">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="d-breadcrumb__item"
        :class="{ 'd-breadcrumb__item--active': item.active }"
        :aria-current="item.active ? 'page' : undefined"
      >
        <router-link
          v-if="item.to && !item.active"
          :to="item.to"
          class="d-breadcrumb__link"
        >
          {{ item.text }}
        </router-link>
        <span v-else class="d-breadcrumb__current">{{ item.text }}</span>
      </li>
    </ol>
  </nav>
</template>

<style scoped>
.d-breadcrumb {
  margin: 0 0 14px 0;
}

.d-breadcrumb__list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 13px;
  line-height: 1.4;
}

.d-breadcrumb__item {
  display: inline-flex;
  align-items: center;
  color: #64748b;
}

.d-breadcrumb__item + .d-breadcrumb__item::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  margin: 0 10px;
  border-right: 1.5px solid #cbd5e1;
  border-top: 1.5px solid #cbd5e1;
  transform: rotate(45deg);
  transition: border-color 0.15s ease;
}

.d-breadcrumb__link {
  color: #64748b;
  text-decoration: none;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 500;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.d-breadcrumb__link:hover {
  background-color: #f1f5f9;
  color: var(--primary-color);
}

.d-breadcrumb__current {
  padding: 4px 8px;
  color: #0f172a;
  font-weight: 600;
}

.d-breadcrumb__item--active {
  color: #0f172a;
}

/* ── Dark mode ─────────────────────────────────────────────── */
[data-theme="dark"] .d-breadcrumb__item {
  color: #9aadc4;
}

[data-theme="dark"] .d-breadcrumb__item + .d-breadcrumb__item::before {
  border-color: #3d5070;
}

[data-theme="dark"] .d-breadcrumb__link {
  color: #9aadc4;
}

[data-theme="dark"] .d-breadcrumb__link:hover {
  background-color: #28364e;
  color: #a8c4ff;
}

[data-theme="dark"] .d-breadcrumb__current {
  color: #e8edf5;
}
</style>
